export default __webpack_public_path__ + "static/media/7.03ed7b5c.webp";